import { t } from "../../../i18n";
import { Button, Dialog } from "../../ui";
import type { Settlement } from "../types";

interface DeleteInvoiceDialogProps {
  invoice: Settlement["invoices"][number] | null;
  expenseCount: number;
  onClose: () => void;
  onConfirm: (invoice: Settlement["invoices"][number]) => void;
}

export function DeleteInvoiceDialog({
  invoice,
  expenseCount,
  onClose,
  onConfirm,
}: DeleteInvoiceDialogProps) {
  return (
    <Dialog
      open={!!invoice}
      onClose={onClose}
      size="sm"
      title={t.settlement.invoices.deleteDialog.title}
      description={
        invoice
          ? t.settlement.invoices.deleteDialog.description(invoice.filename, expenseCount)
          : ""
      }
      footer={
        <>
          <Button onClick={onClose}>{t.common.cancel}</Button>
          <Button
            variant="danger"
            iconLeft="trash"
            disabled={!invoice}
            onClick={() => invoice && onConfirm(invoice)}
          >
            {t.settlement.invoices.deleteDialog.submit}
          </Button>
        </>
      }
    />
  );
}
